import { UIWRoomUserListController } from './UIWRoomUserListController.ts';
import { UIWRoomCenterController } from './UIWRoomCenterController.ts';
import { Scene } from '../UISceneTypes.ts';
import { UIRoomChatController } from './UIRoomChatController.ts';
import { UIUtilsEjsVariables } from '../../../../shared/scripts/UIUtilsEjsVariables.ts';
import { PIXI } from '@colonist/pixi';
import { removeHash } from '../../../../shared/scripts/ui_utils/Utils.ts';
import { LobbyImage } from '@colonist/types';
import { UIRoomFriendListController } from '../../../../shared/scripts/ui_html/room/UIRoomFriendListController.ts';
import { UIRoomPlayOrderSelectionController } from './play_order_selection/UIRoomPlayOrderSelectionController.ts';
import { UIDRoomFriendListController } from './UIDRoomFriendListController.ts';
import { UIRoomSettingsController } from '../../../../shared/scripts/ui_room/UIRoomSettingsController.ts';
import { notificationController, socket } from '../../../../shared/scripts/EntryShared.ts';
import { RoomStateChangerNotifier } from '../../../../shared/scripts/RoomStateChangerNotifier.ts';
import { showSimpleDialog } from '../../../../shared/scripts/ui_popup/showSimpleDialog.ts';
import { UINotificationSendHelper } from '../../../../shared/scripts/notifications/UINotificationSendHelper.ts';
export class UIRoomController {
    hide() {
        this.container.style.display = 'none';
        this.userList.clear();
    }
    show() {
        var _this_friendList;
        this.container.style.display = 'flex';
        if (this.roomState == undefined) return;
        this.userList.load(this.roomState);
        this.center.load(this.roomState);
        (_this_friendList = this.friendList) === null || _this_friendList === void 0 ? void 0 : _this_friendList.updateRoomState(this.roomState);
    }
    updateRoom(roomState) {
        if (this.roomState != undefined && roomState.updateSequence < this.roomState.updateSequence) return;
        if ((socket === null || socket === void 0 ? void 0 : socket.lobbyListener) != undefined) socket.lobbyListener.room = roomState // TODO remove when socket.lobbyListener.room is not used anymore
        ;
        this.refreshBrowserIfCurrentSceneIsGame();
        if (this.roomInitiated) {
            this.updateCurrentRoom(roomState);
            return;
        }
        this.initRoom(roomState);
    }
    updateSeedOrderSelection(data) {
        if (this.roomState == undefined) return;
        this.center.updateSeedOrderSelection(this.roomState, data);
        this.playOrderSelectionController.seedOrder = data;
        this.center.update(undefined, this.roomState);
    }
    updatePlayOrderSelection(data) {
        if (this.roomState == undefined) return;
        this.playOrderSelectionController.update(this.roomState, data);
    }
    leaveRoom(toScene, data, forceLeave = false) {
        var _this_roomState;
        toScene !== null && toScene !== void 0 ? toScene : toScene = Scene.Lobby;
        const goToScene = ()=>this.uiManager.sceneController.loadScene(toScene, data);
        if (((_this_roomState = this.roomState) === null || _this_roomState === void 0 ? void 0 : _this_roomState.isMultiplayer()) && !forceLeave) {
            this.confirmLeaveRoom(goToScene);
            return;
        }
        this.resetRoom();
        goToScene();
    }
    confirmLeaveRoom(onLeave) {
        showSimpleDialog({
            title: {
                key: 'strings:roomPage.leaveRoom.title'
            },
            body: {
                key: 'strings:roomPage.leaveRoom.body'
            },
            onConfirm: ()=>{
                this.resetRoom();
                onLeave();
            },
            showCancelBtn: true
        });
    }
    onKickedInactiveHost() {
        var _this_roomState;
        if ((_this_roomState = this.roomState) === null || _this_roomState === void 0 ? void 0 : _this_roomState.isHost(socket.controller.session.id)) {
            this.chat.post({
                icon: LobbyImage.Lightning,
                text: {
                    key: 'strings:roomPage.notifications.kickedDueToInactivity'
                }
            });
        }
        notificationController.showNotification(LobbyImage.Lightning, {
            key: 'strings:roomPage.notifications.kickingInactiveHost'
        });
    }
    resetRoom() {
        if (this.roomState != undefined) UIRoomSettingsController.snapshotRoomSettings(this.roomState, socket.controller.session.id);
        socket.roomClient.leave();
        this.roomInitiated = false;
        this.roomState = undefined;
        this.userList.clear();
        this.chat.clear();
        removeHash();
    }
    initRoom(roomState) {
        var _this_friendList;
        UIRoomController.updateURLToRoom(roomState.gameSetting.id);
        this.roomInitiated = true;
        this.roomState = roomState;
        this.friendList.setRoomId(roomState.gameSetting.id);
        UIRoomSettingsController.initRoomSettingFromLocalStorage(roomState.gameSetting.modeSetting);
        this.playOrderSelectionController = new UIRoomPlayOrderSelectionController();
        this.uiManager.sceneController.loadScene(Scene.Room);
        (_this_friendList = this.friendList) === null || _this_friendList === void 0 ? void 0 : _this_friendList.animateInviteFriendsButton();
        UINotificationSendHelper.registerToNotificationServiceAndGetNotifications();
    }
    updateCurrentRoom(newRoomState) {
        var _this_friendList;
        this.userList.update(newRoomState);
        (_this_friendList = this.friendList) === null || _this_friendList === void 0 ? void 0 : _this_friendList.updateRoomState(newRoomState);
        this.center.update(this.roomState, newRoomState);
        RoomStateChangerNotifier.run(this.roomState, newRoomState);
        this.roomState = newRoomState;
    }
    refreshBrowserIfCurrentSceneIsGame() {
        const isUserInGame = this.uiManager.sceneController.scene == Scene.Game;
        if (!isUserInGame) return;
        location.reload();
    }
    static updateURLToRoom(gameId) {
        if (window.location.hash == '#' + gameId) return;
        window.location.hash = gameId;
    }
    updatePageOnHashChange() {
        window.onhashchange = (hashChangeEvent)=>{
            const oldUrl = new URL(hashChangeEvent.oldURL);
            const newUrl = new URL(hashChangeEvent.newURL);
            const adHash = '#goog_rewarded';
            if (newUrl.hash == adHash || oldUrl.hash == adHash) {
                history.replaceState(null, document.title, window.location.pathname + window.location.search);
                return;
            }
            const isTheSameHash = oldUrl.hash.toLocaleLowerCase() == newUrl.hash.toLocaleLowerCase();
            if (isTheSameHash) return;
            const hashesNotEmpty = oldUrl.hash != '' && newUrl.hash != '';
            if (hashesNotEmpty) {
                location.reload();
                return;
            }
            const sceneIsRoom = this.uiManager.sceneController.scene == Scene.Room;
            const sceneIsGame = this.uiManager.sceneController.scene == Scene.Game;
            const roomAlreadyInitiated = sceneIsRoom && this.roomInitiated;
            const newHashIsSet = newUrl.hash != '';
            if (roomAlreadyInitiated) return;
            if (sceneIsGame && newHashIsSet) return;
            location.reload();
        };
    }
    static showHeaderInRoom() {
        if (UIUtilsEjsVariables.isUserOnDiscordMobile) return true;
        if (UIUtilsEjsVariables.isUserOnMobileAppOrWeb) return false;
        if (PIXI.utils.isMobile.phone) return false;
        return true;
    }
    updateAllFriendsOnlineStatus(friends) {
        var _this_friendList;
        (_this_friendList = this.friendList) === null || _this_friendList === void 0 ? void 0 : _this_friendList.updateFriendsList(friends);
    }
    updateFriendOnlineStatus(friend) {
        var _this_friendList;
        (_this_friendList = this.friendList) === null || _this_friendList === void 0 ? void 0 : _this_friendList.updateFriendOnlineStatus(friend);
    }
    toggleFriendInviteButtonState(responderUserId, enable) {
        var _this_friendList;
        (_this_friendList = this.friendList) === null || _this_friendList === void 0 ? void 0 : _this_friendList.toggleFriendInviteButtonState(responderUserId, enable);
    }
    getSessionByUserSessionId(userSessionId) {
        var _this_roomState;
        return (_this_roomState = this.roomState) === null || _this_roomState === void 0 ? void 0 : _this_roomState.getSessions().find((session)=>session.userSessionId == userSessionId);
    }
    constructor(uiManager){
        this.roomInitiated = false;
        this.uiManager = uiManager;
        this.container = document.getElementById('scene_room_container');
        this.userList = new UIWRoomUserListController();
        this.chat = new UIRoomChatController();
        this.center = new UIWRoomCenterController();
        const friendListContainer = document.getElementById('scene_room_friend_list');
        const friendHeader = document.getElementById('scene_room_left_friend_header');
        const friendPlayerList = document.getElementById('scene_room_player_list');
        this.friendList = UIUtilsEjsVariables.isUserOnDiscord ? new UIDRoomFriendListController(friendListContainer, friendHeader, friendPlayerList) : new UIRoomFriendListController(friendListContainer, friendHeader, friendPlayerList);
        this.updatePageOnHashChange();
    }
}
